import LimitedCharacterInput from '../limited-character-input';
const maxTextfieldLength = 100;
const maxTextareaLength = 500;
export default class SurveyItemBase {
    constructor(wrapper) {
        this.controlQuestionId = ''; // id of the question that this question depend on, nullable
        this.controlValue = ''; // show this question if user select this value of the control question
        this.controlAnswerInputs = []; // all related inputs that control the hide/show functionality
        this.checkControlQuestion = () => {
            // prepare regex
            const regex = new RegExp(`(^|\\s|)${this.controlValue}($|\\s)`, "i");
            let show = false;
            // check all related inputs
            this.controlAnswerInputs.forEach(input => {
                // check if input matched
                const isMatched = regex.test(input.value);
                // text field
                if (input.type === "text" || input.type === "number") {
                    if (isMatched) {
                        show = true;
                    }
                    return;
                }
                // radio buttons & checkboxes
                else if (input.type === "radio" || input.type === "checkbox") {
                    // As we have multiple radio buttons or checkboxes
                    // We also need to test if this input is checked
                    if (isMatched && input.checked) {
                        show = true;
                    }
                }
            });
            // show/hide
            if (show) {
                this.Show();
            }
            else {
                this.Hide();
            }
        };
        //protected triggerSelectValue = (answer) => {
        //    this.selectedAnswer = answer;
        //    this.wrapper.setAttribute("data-selected-value", this.selectedAnswer);
        //    // trigger event
        //    this.wrapper.dispatchEvent(new CustomEvent("answer", { detail: this.selectedAnswer }))
        //}
        this._addCharacterLimit = () => {
            // get all input and textarea
            const inputElements = [].slice.call(this.wrapper.querySelectorAll('input[type="text"], input[type="number"], textarea'));
            // loop all elements
            inputElements.forEach(element => {
                // add maxlength
                if (element.tagName.toLowerCase() === "input") {
                    new LimitedCharacterInput(element, maxTextfieldLength).init();
                }
                else {
                    new LimitedCharacterInput(element, maxTextareaLength).init();
                }
            });
        };
        this.Hide = () => {
            // set element height
            this.wrapper.style.height = this.wrapper.scrollHeight + "px";
            // allow animation
            setTimeout(() => {
                this.wrapper.classList.add("survey-item--disabled", "validation-ignore");
            }, 0);
            // set height by fixed value to achieve transition effect
            //const height = this.answerAreaElement.offsetHeight;
            //this.answerAreaElement.style.height = height + "px";
            //// collapse in different thread
            //setTimeout(() => {
            //    this.answerAreaElement.classList.add("survey-animate");
            //    this.answerAreaElement.classList.remove("show");
            //}, 0);
            // disabled all inputs
            this._setDisabledState();
            // clear all input
            // get all input and textarea
            const inputElements = [].slice.call(this.wrapper.querySelectorAll('input:not([type="hidden"]), textarea'));
            inputElements.forEach(element => {
                // uncheck
                if (element.type == "checkbox" || element.type == "radio") {
                    element.checked = false;
                }
                else {
                    // clear text
                    element.value = '';
                }
                // remove active state
                if (element.closest(".survey-item-answer")) {
                    element.closest(".survey-item-answer").classList.remove("active");
                }
                // trigger change event
                element.dispatchEvent(new Event("change"));
            });
        };
        this.Show = () => {
            // revert disabled state
            this._setDisabledState(true);
            setTimeout(() => {
                this.wrapper.classList.add("survey-item--show");
                // set element height
                this.wrapper.style.height = this.wrapper.scrollHeight + "px";
            }, 0);
            // allow animation
            setTimeout(() => {
                this.wrapper.classList.remove("survey-item--disabled", "validation-ignore");
            }, 0);
            //if (this.answerAreaElement && !this.answerAreaElement.classList.contains("show")) {
            //    // expand
            //    this.wrapper.classList.remove("survey-item--disabled", "validation-ignore");
            //    //this.wrapper.dispatchEvent(new Event("show"));
            //    this.answerAreaElement.classList.remove("survey-animate");
            //    this.answerAreaElement.classList.add("show");
            //}
        };
        this._setDisabledState = (fromDefault = false) => {
            const formInputs = this.wrapper.querySelectorAll("input, select, textarea");
            // revert to initial disabled state
            if (fromDefault) {
                formInputs.forEach(element => {
                    const disabled = element.getAttribute("data-disabled") || "";
                    if (!!disabled) {
                        element.setAttribute("disabled", "");
                    }
                    else {
                        element.removeAttribute("disabled");
                    }
                });
            }
            else {
                // disabled all fields and store initial state
                formInputs.forEach(element => {
                    const disabled = element.getAttribute("disabled") || "";
                    // store default state
                    if (!element.hasAttribute("data-disabled")) {
                        element.setAttribute("data-disabled", disabled);
                    }
                    // set disabled
                    element.setAttribute("disabled", "");
                });
            }
        };
        this.wrapper = wrapper;
        if (wrapper) {
            this.id = this.wrapper.getAttribute("data-qn-id");
            this.answerAreaElement = this.wrapper.querySelector(".survey-item-answer-area");
            // clean up animation styles on answer expanded
            this.wrapper.addEventListener("transitionend", () => {
                this.wrapper.removeAttribute("style");
                if (this.wrapper.classList.contains("survey-item--disabled")) {
                    this.wrapper.classList.remove("survey-item--show");
                }
            });
            // get conditional parameters
            if (this.wrapper.hasAttribute("data-display-if-qn") && this.wrapper.hasAttribute("data-display-if-value")) {
                this.controlQuestionId = this.wrapper.getAttribute("data-display-if-qn");
                this.controlValue = this.wrapper.getAttribute("data-display-if-value");
            }
            // register hide/show event
            let constrolQuestionExist = false;
            if (this.controlQuestionId.length > 0 && this.controlValue.length > 0) {
                // get control value
                this.controlValue = this.controlValue.toLowerCase();
                // get control inputs
                this.controlAnswerInputs = [].slice.call(document.querySelectorAll(`input[name*="${this.controlQuestionId}"]:not([type="hidden"])`));
                // perform control question checking
                this.controlAnswerInputs.forEach(input => {
                    // add checking event
                    input.addEventListener("change", () => {
                        console.log('TRIGGER', input, 'RECEIVER', this.wrapper);
                        this.checkControlQuestion();
                    });
                    // default checking
                    this.checkControlQuestion();
                });
                constrolQuestionExist = this.controlAnswerInputs.length > 0;
            }
            if (!constrolQuestionExist) {
                // just show question
                this.wrapper.classList.add("survey-item--show");
            }
            // implement character limit to text field
            this._addCharacterLimit();
        }
    }
}
;
